const { getElement, getElements } = window.BAO.Utils

class ImageTextGrid extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document,
      'DOMContentLoaded',
      this.moveContent.bind(this),
    )

    if (!this.externalEls?.readmore?.exists || !this.sectionId) return
    this.handleReadMoreClick = this.handleReadMoreClick.bind(this)
    this.externalEls.readmore.elements.forEach(readMoreEl => {
      readMoreEl.setAttribute('aria-hidden', 'false')
      readMoreEl.setAttribute('href', `#sec-ImageTextGrid_Item-image`)
      this.listeners.add(readMoreEl, 'click', this.handleReadMoreClick)
    })
  }

  moveContent () {
    if (
      this.classList.contains('clc-ImageTextGrid') !== true &&
      this.collectionProductGridColumn === null
    ) {
      return
    }

    this.collectionProductGridColumn.appendChild(this)
  }

  handleReadMoreClick () {
    this.firstkeyBoardFocusableElement.focus()
  }

  get collectionProductGridColumn () {
    return getElement('.clc-ProductGrid_Column-facetsTarget')
  }

  get firstkeyBoardFocusableElement () {
    return this.keyboardFocusableElements?.[0]
  }

  get keyboardFocusableElements () {
    return [
      ...getElements(
        'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
        { context: this },
      ),
    ].filter(
      el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'),
    )
  }

  get sectionId () {
    return this.closest('.shopify-section')?.getAttribute('id')
  }
}

if (!customElements.get('image-text-grid')) {
  customElements.define('image-text-grid', ImageTextGrid)
}
